import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OAuthModule } from 'angular-oauth2-oidc';

@NgModule({
  imports: [
    CommonModule,
    OAuthModule.forRoot({
      resourceServer: {
        sendAccessToken: true,
        // TODO: Add our API endpoint here
        // hier stehen die API's / Endpunkte, welche das Token empfangen dürfen. Aus Sicherheitsgründen darf es natürlich nicht an jeden Request gehängt werden
        allowedUrls: ['http://www.angular.at/api/'],
      },
    }),
  ],
})
export class Oauth2OidcModule {}
